import stringify from 'json-stringify-pretty-compact';
import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { omit } from 'vega-lite';
import * as themes from 'vega-themes';
import * as EditorActions from '../../actions/editor';
import './config-editor.css';
class ConfigEditorHeader extends React.PureComponent {
    render() {
        const vegaThemes = omit(themes, ['version']);
        return (React.createElement("label", { className: "config-header" },
            "Theme:",
            React.createElement("select", { value: this.props.themeName, onClick: (e) => e.stopPropagation(), id: "config-select", onChange: (e) => {
                    e.stopPropagation();
                    if (e.target.value === 'custom') {
                        this.props.setConfig('{}');
                        this.props.setConfigEditorString('{}');
                    }
                    else {
                        this.props.setConfig(stringify(vegaThemes[e.target.value]));
                        this.props.setConfigEditorString(stringify(vegaThemes[e.target.value]));
                    }
                    this.props.setThemeName(e.target.value);
                } },
                React.createElement("option", { value: "custom" }, "Custom"),
                Object.keys(vegaThemes).map((keyName) => (React.createElement("option", { key: keyName, value: keyName }, keyName))))));
    }
}
export function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        setConfig: EditorActions.setConfig,
        setConfigEditorString: EditorActions.setConfigEditorString,
        setThemeName: EditorActions.setThemeName,
    }, dispatch);
}
function mapStateToProps(state) {
    return {
        manualParse: state.manualParse,
        themeName: state.themeName,
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(ConfigEditorHeader);
